import { Character } from "@moe/priv/model/character";
import { HorizontalCard } from "@web/route-services/index/HorizontalCard";
import { VerticalCard } from "@web/route-services/index/VerticalCard";
import { useAppContext } from "../root/AppContext";

interface Props {
  char: Character;
  isPending: boolean;
  [key: string]: any;
}

export function FeaturedCard({ char, isPending, ...rest }: Props) {
  const { isDesktopScreen } = useAppContext();
  if (isDesktopScreen) {
    return <HorizontalCard char={char} isPending={isPending} {...rest} />;
  }
  return <VerticalCard char={char} isPending={isPending} {...rest} className="h-full w-[232px]" />;
}
